import BaseRepository from './base.repository';

class NotificationsRepository extends BaseRepository {
  constructor() {
    super('/notifications');
  }

  find(params) {
    return this.client.get('', params);
  }

  getUnreadCount() {
    return this.client.get('/unread-count');
  }

  get(itemUnique) {
    return this.client.get(`/${itemUnique}`);
  }

  read(itemUnique) {
    return this.client.patch(`/${itemUnique}/read`, {});
  }

  respond(itemUnique, request) {
    return this.client.post(`/${itemUnique}/actions`, request);
  }
}

export default new NotificationsRepository();
